import BlogQuoteLayoutContainer from "../../../../components/pages/blog/blogDetail/BlogQuoteLayout";

const BlogQuoteLayout = () => {
  return <BlogQuoteLayoutContainer />;
};

export default BlogQuoteLayout;
